var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-report__stats-box" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "sales-report__body" },
      [
        _c("ChartCustom", {
          attrs: {
            "chart-settings": _vm.chartConfig,
            dimensions: _vm.chartConfig.size
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "css-grid sales-report__header" }, [
      _c("div", { staticClass: "sales-report__header-name" }, [
        _vm._v("Average Cost Per Unit")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }